import React from "react";
import classes from "./style.module.scss";
import resultBannerImage from "../../assets/images/result-banner.png";

const ResultScore = (props) => {
  const { score } = props;

  return (
    <>
      {/* <div className="result-final-score-wrapper">
        <div className={classes.root } >
          <img className={classes.resultBannerImage} src={resultBannerImage} alt="resultBannerImage"/>
          <p className={classes.score} >{score}</p>
        </div>
      </div> */}
    </>
  );
};

export default ResultScore;
